import { useState } from 'react';
import type { InstituteType } from '../types/instituteType.types';

interface InstituteTypeModalState {
  instituteType: InstituteType | null;
}

export function useInstituteTypeActionModals() {
  const [modalState, setModalState] = useState<InstituteTypeModalState | null>(null);
  const [instituteTypeToDelete, setInstituteTypeToDelete] = useState<InstituteType | null>(null);

  return {
    modalState,
    instituteTypeToDelete,
    openCreateModal: () => setModalState({ instituteType: null }),
    openEditModal: (instituteType: InstituteType) => setModalState({ instituteType }),
    closeModal: () => setModalState(null),
    openDeleteModal: setInstituteTypeToDelete,
    closeDeleteModal: () => setInstituteTypeToDelete(null),
  };
}
